/*:: type weekdayType = 'Mon' | 'Tue' | 'Wed' | 'Thu' | 'Fri' | 'Sat' | 'Sun';*/

class Pin {
  /*:: static toJson: (Pin) => Object; */

  /*:: static fromJson: (Object) => Pin; */
  constructor({
    /*: {
        pin: string, skips: number, weekday?: weekdayType
      }*/

    pin,
    skips = 0,
    weekday
  }) {
    this.pin = pin;
    this.skips = skips || 0;
    this.weekday = weekday;
  }

}

Pin.fromJson = (json
/*: Object*/
) => new Pin({
  pin: json.pin,
  skips: json.skips,
  weekday: json.weekday
});

Pin.toJson = (pin
/*: Pin*/
) => ({
  pin: pin.pin,
  skips: pin.skips,
  weekday: pin.weekday
});

module.exports = Pin;